<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Card :bordered="false" dis-hover>
                <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目信息</template>
                <DescriptionList class="show-description-title" title="" :col="3" layout="vertical">
                    <Description term="项目名称：">
                        {{detail.name}}
                    </Description>
                    <Description term="项目类型：">
                        <Tag>{{detail.type_name}}</Tag>
                    </Description>
                    <Description term="项目状态：">
                        {{detail.status_name}}
                    </Description>
                    <Description term="甲方：">
                        {{detail.customer_name ?? '-'}}
                    </Description>
                    <Description term="联系电话：">
                        {{detail.mobile ?? '-'}}
                    </Description>
                    <Description term="微信号：">
                        {{detail.wechat ?? '-'}}
                    </Description>
                    <Description term="负责人：">
                        {{detail.head_name}}
                    </Description>
                    <Description term="项目金额：">
                        <Tag color="blue">{{detail.money}}</Tag>
                    </Description>
                    <Description term="合同金额：">
                        <Tag color="green">{{detail.contract_money}}</Tag>
                    </Description>
                    <Description term="签订人：">
                        {{detail.contract_signa_name ?? '-'}}
                    </Description>
                    <Description term="合同开始：">
                        {{detail.contract_start_time ?? '-'}}
                    </Description>
                    <Description term="合同结束：">
                        {{detail.contract_end_time ?? '-'}}
                    </Description>
                    <Description term="维保周期：">
                        {{detail.maintain_cycle ?? '-'}}
                    </Description>
                </DescriptionList>
                <DescriptionList class="show-description-title" title="" :col="1" layout="vertical">
                    <Description term="合同资料：">
                        <a href="javascript:void(0);" v-if="detail.contract_file" @click="FileDownload(detail.contract_file)">下载文件</a>
                        <span v-else>-</span>
                    </Description>
                    <Description term="项目说明：">
                        {{detail.project_desc ?? '-'}}
                    </Description>
                    <Description term="项目备注：">
                        {{detail.remark ?? '-'}}
                    </Description>
                    <Description term="更新时间：">
                        {{detail.update_time ?? '-'}}
                    </Description>
                </DescriptionList>
            </Card>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">关闭</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedDetail} from "@/apis/dispersed";

export default {
    name: 'DispersedShow',
    components: {
    },
    data () {
        return {
            title: '零星项目详情',
            isBox: false,
            detail: [],
            site_url : this.$siteApi,
        }
    },
    methods: {
        /**
         功能：文件下载
         time: 2026/09/12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        getDetail(small_project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedDetail(small_project_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：打开
         time: 2026/09/12
         **/
        show(small_project_id){
            this.isBox = true;
            if(small_project_id) this.getDetail(small_project_id);
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '零星项目详情';
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
